import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Grid, Checkbox } from '@material-ui/core'
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'

const useStyles = makeStyles(theme => ({
  checkboxRoot: {
    padding: 3
  },
  checked: {
    color: theme.palette.info.main
  },
  filledCheckedMark: {
    position: 'absolute',
    width: 10,
    height: 10,
    backgroundColor: 'var(--bg-color-7)'
  },
  label: {
    fontWeight: 400
  },
  checkboxIcon: {
    color: 'var(--border-color-13)'
  }
}))

const HiTrackedOnlyToggle = ({
  id,
  checked = false,
  disabled = false,
  onToggle = () => {},
  label = '',
  className = ''
}) => {
  const classes = useStyles()

  const checkboxOffComponent = useMemo(
    () => <CheckBoxOutlineBlank className={classes.checkboxIcon} />,
    [classes.checkboxIcon]
  )
  const checkboxOnComponent = useMemo(
    () => (
      <div className={'MuiIconButton-label'}>
        <CheckBoxOutlineBlank className={classes.checkboxIcon} />
        <div className={classes.filledCheckedMark} />
      </div>
    ),
    [classes.filledCheckedMark, classes.checkboxIcon]
  )

  return (
    <Grid container alignItems="center" wrap="nowrap" className={className}>
      <Grid item>
        <Checkbox
          id={id}
          icon={checkboxOffComponent}
          checkedIcon={checkboxOnComponent}
          classes={{ checked: classes.checked, root: classes.checkboxRoot }}
          checked={checked}
          disabled={disabled}
          onChange={onToggle}
        />
      </Grid>
      <Grid item zeroMinWidth>
        <DazzedParagraph12 className={classes.label}>{label}</DazzedParagraph12>
      </Grid>
    </Grid>
  )
}

export default HiTrackedOnlyToggle
